import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../../../../Icon';
import PrivacyIcon from '../../../../../PrivacyIcon';
import { formatDate } from '../../../../utils';
import styles from '../index.styl';

const ProcedureCard = ({ entity, formatMessage }) => {
  const [activeCard, setActiveCard] = useState(false);
  const {
    beginDate,
    endDate,
    performingProviderName,
    name,
    locationName,
    isPrivate,
  } = entity;

  const safeDate = endDate || beginDate;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.leftSideWrapper}>
          <Icon
            size={28}
            name="icon-procedures-black"
            className={styles.iconType}
          />
          <div className={styles.contentWrapper}>
            <div className={styles.title}>
              <div
                className={cn(styles.titleWrapper, { [styles.noTitle]: !name })}
              >
                {name}
              </div>
              <PrivacyIcon show={isPrivate} className={styles.privacyIcon} />
            </div>
            <div className={styles.description}>
              {safeDate ? formatDate(safeDate, 'MMM D, Y') : ''}
            </div>
          </div>
        </div>
        <Icon
          size={16}
          name={activeCard ? 'icon-arrow-up' : 'icon-arrow-down'}
          className={styles.icon}
          onClick={() => setActiveCard(!activeCard)}
        />
      </div>
      {activeCard && (
        <div className={styles.activeCardRoot}>
          <div className={styles.columnWrapper}>
            <div className={styles.column}>
              <div className={styles.meta}>
                {formatMessage({
                  id: 'messages.nav.tabs.provider',
                })}
              </div>
            </div>
            <div className={styles.column}>
              <div className={styles.fullContent}>
                {performingProviderName || ''}
              </div>
            </div>
          </div>
          <div className={styles.columnWrapper}>
            <div className={styles.column}>
              <div className={styles.meta}>
                {formatMessage({ id: 'profile.fields.location' })}
              </div>
            </div>
            <div className={styles.column}>
              <div className={styles.fullContent}>{locationName || ''}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ProcedureCard.propTypes = {
  entity: PropTypes.object,
  formatMessage: PropTypes.func,
};

export default ProcedureCard;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/ProcedureCard/index.jsx